/**
 * This class implements a pseudo bus that stores the latest value
 * sent on a given topic and will always trigger the callback at least once
 * upon subscribing.
 *
 * Close to a [BehaviorSubject from RxJS](https://github.com/ReactiveX/rxjs/blob/master/doc/subject.md#behaviorsubject)
 */
var Bus = /** @class */ (function () {
    function Bus() {
        this.subscribers = {};
        this.lastValues = {};
    }
    /**
     * Publish data on a given topic
     * @param topicName the topic name
     * @param payload the payload to publish
     */
    Bus.prototype.publish = function (topicName, payload) {
        this.lastValues[topicName] = payload;
        var topicSubscribers = this.subscribersForTopic(topicName);
        topicSubscribers.forEach(function (s) { return s(payload); });
    };
    /**
     * Subscribe to a given topic
     * @param topicName the topic name
     * @param cb will be called anytime the current value on the topic changes
     *  and at least once initially with the current value (or `undefined` if
     *  nothing has been published yet).
     * @return a subscription handle you need to use to unsubscribe.
     */
    Bus.prototype.subscribe = function (topicName, cb) {
        if (!cb || typeof cb !== "function") {
            return undefined;
        }
        var topicSubscribers = this.subscribersForTopic(topicName);
        topicSubscribers.push(cb);
        // Always publish the current value (even if it is undefined !)
        var currentValue = this.lastValues[topicName];
        cb(currentValue);
        // The handle contains the topic name and a reference to the callback
        return {
            cb: cb,
            topicName: topicName,
        };
    };
    /**
     * Stop a subscription.
     * @param subscription the subscription handle received from your subscribe call.
     */
    Bus.prototype.unsubscribe = function (handle) {
        var topicSubscribers = this.subscribersForTopic(handle.topicName);
        var subscriberIndex = topicSubscribers.indexOf(handle.cb);
        if (subscriberIndex !== -1) {
            topicSubscribers.splice(subscriberIndex, 1);
        }
    };
    /**
     * Get the current value of a given topic (`undefined` if nothing has been published yet).
     *
     * **WARNING**: You will not be notified when the value changes and this
     * can lead to strange bugs.
     * @param topicName the topic name
     */
    Bus.prototype.dangerouslyGetCurrentValue = function (topicName) {
        return this.lastValues[topicName];
    };
    Bus.prototype.subscribersForTopic = function (topicName) {
        var topicSubscribers = this.subscribers[topicName];
        if (!topicSubscribers) {
            this.subscribers[topicName] = topicSubscribers = [];
        }
        return topicSubscribers;
    };
    return Bus;
}());
export { Bus };
//# sourceMappingURL=Bus.js.map